var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgUpload = function SvgUpload(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 49.53 29.39"
  }, props), _path || (_path = React.createElement("path", {
    fill: "currentColor",
    d: "M49.53 10.17L39.46 0 29.38 10.17l2.44 2.42 5.92-5.96v19.32H3.44V4.16h23.05V.72H0v28.67h41.18V6.63l5.91 5.96 2.44-2.42z",
    "data-name": "Layer 2"
  })));
};
export default __webpack_public_path__ + "c3f84284b31074ff06295454e43ff1c2.svg";
export { SvgUpload as ReactComponent };